import Typography from '@mui/material/Typography';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 24rem;

  border-right: 1px solid ${({ theme }) => theme.palette.grey[400]};
  // background: ${({ theme }) => theme.palette.background.default};
`;

export const TitleContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(5)} ${theme.spacing(3)}`};
`;

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  flex: 1;
  min-height: 0;
  overflow-y: auto;

  padding: ${({ theme }) => `0 ${theme.spacing(2)} ${theme.spacing(2)}`};
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const GroupHeader = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(3)}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};
`;

export const Version = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
